import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_DOCUMENT_IMPORTER__BY_ID } from './get-document-importer-by-id.hook';
import { GET_DOCUMENTS_IMPORTER } from './get-documents-importer.hook';

export const DELETE_DOCUMENT_IMPORTER_BY_ID = gql`
  mutation deleteDocumentImporterById($id: String!) {
    deleteDocumentImporter(id: $id) {
      _id
    }
  }
`;

export const useDeleteDocumentImporterById = () => {
  const { t } = useTranslation('settings');
  const [deleteDocumentImporterById] = useMutation(DELETE_DOCUMENT_IMPORTER_BY_ID, {
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [GET_DOCUMENT_IMPORTER__BY_ID, GET_DOCUMENTS_IMPORTER],
  });

  return deleteDocumentImporterById;
};
